import { IxNotifications } from './IxNotifications.js';

window.customElements.define('ix-notifications', IxNotifications);
